import { render, staticRenderFns } from "./BeforeAfter.vue?vue&type=template&id=c3dad938&scoped=true&"
import script from "./BeforeAfter.vue?vue&type=script&lang=js&"
export * from "./BeforeAfter.vue?vue&type=script&lang=js&"
import style0 from "./BeforeAfter.vue?vue&type=style&index=0&id=c3dad938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dad938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3dad938')) {
      api.createRecord('c3dad938', component.options)
    } else {
      api.reload('c3dad938', component.options)
    }
    module.hot.accept("./BeforeAfter.vue?vue&type=template&id=c3dad938&scoped=true&", function () {
      api.rerender('c3dad938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/Next/ContentBlock/BeforeAfter/BeforeAfter.vue"
export default component.exports